import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetOptOverallsIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsOverall/GetOptOverallsIncidents`,
	params: { userId, role }
});

export const GetOptOverallIncidentDetailsRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsOverall/GetOptOverallIncidentDetails`,
	params: { userId, tableId }
});

export const GetOptOverallIncidentDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsOverall/GetOptOverallIncidentDropdowns`
});

export const EditOptOverallIncidentDetailsRequest = (optimizationsOverallDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsOverall/EditOptOverallIncidentDetails`,
	data: optimizationsOverallDto
});

export const CreateOptOverallIncidentRequest = (optimizationsOverallDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsOverall/CreateOptOverallIncident`,
	data: optimizationsOverallDto
});

export const DeleteOptOverallIncidentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsOverall/DeleteOptOverallIncident`,
	params: { userId, tableId }
});

export const ExportOptOverallsIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsOverall/ExportOptOverallsIncidents`,
	params: { userId, role }
});
